module.exports = __webpack_public_path__ + "img/0101.db03b98b.png";